import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h4', [_vm._v("OS")]), _c('RelatorioEmpresasSelector'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', [_vm._v("Resumo das Ordens de Serviço:")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_inicial_os",
      "label-for": "data_inicial_os",
      "label": "Data Inicial de entrada"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_inicial_os,
      callback: function callback($$v) {
        _vm.data_inicial_os = $$v;
      },
      expression: "data_inicial_os"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_final_os",
      "label-for": "data_final_os",
      "label": "Data Final de entrada"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_final_os,
      callback: function callback($$v) {
        _vm.data_final_os = $$v;
      },
      expression: "data_final_os"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "filterable": false,
      "options": _vm.clientes
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.cliente_os,
      callback: function callback($$v) {
        _vm.cliente_os = $$v;
      },
      expression: "cliente_os"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Técnico",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarTecnico",
    attrs: {
      "filterable": false,
      "options": _vm.tecnicos
    },
    on: {
      "input": _vm.setTecnico,
      "open": _vm.onSearchTecnico,
      "search": _vm.onSearchTecnico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.tecnico_os,
      callback: function callback($$v) {
        _vm.tecnico_os = $$v;
      },
      expression: "tecnico_os"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do técnico ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Objeto",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarObjeto",
    attrs: {
      "filterable": false,
      "options": _vm.objetos
    },
    on: {
      "input": _vm.setObjeto,
      "open": _vm.onSearchObjeto,
      "search": _vm.onSearchObjeto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.descricao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.objeto_os,
      callback: function callback($$v) {
        _vm.objeto_os = $$v;
      },
      expression: "objeto_os"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descrição do objeto ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Selecione o status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.osStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.statusSelectedOS,
      callback: function callback($$v) {
        _vm.statusSelectedOS = $$v;
      },
      expression: "statusSelectedOS"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Comissão do técnico no serviço",
      "label-for": "comissao_tecnico"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "comissao_tecnico",
      "name": "comissao_tecnico"
    },
    model: {
      value: _vm.comissao_tecnico_servico,
      callback: function callback($$v) {
        _vm.comissao_tecnico_servico = $$v;
      },
      expression: "comissao_tecnico_servico"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Solicitante",
      "label-for": "solicitante"
    }
  }, [_c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "id": "solicitante",
      "name": "solicitante"
    },
    model: {
      value: _vm.solicitante,
      callback: function callback($$v) {
        _vm.solicitante = $$v;
      },
      expression: "solicitante"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "custo_produtos",
      "label-for": "custo_produtos",
      "label": "Gerar custo dos produtos"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": false,
      "checked": _vm.custo_produtos == true
    },
    on: {
      "change": _vm.setCustoItens
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escolha a ordenação",
      "label-for": "ordenacao"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ordenacao_os,
      expression: "ordenacao_os"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordenacao_os",
      "id": "ordenacao_os"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.ordenacao_os = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.ordenacao_os_det, function (o, index) {
    return _c('option', {
      key: 'campo' + index,
      domProps: {
        "value": o.campo
      }
    }, [_vm._v(" " + _vm._s(o.descricao) + " ")]);
  }), 0)])], 1)], 1), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.gerarResumoOS();
      }
    }
  }, [_vm._v(" Gerar ")])], 1)])], 1)]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', [_vm._v("Resumo das Ordens de Serviço com horários:")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_inicial_os_horario",
      "label-for": "data_inicial_os_horario",
      "label": "Data Inicial de entrada"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_inicial_os_horario,
      callback: function callback($$v) {
        _vm.data_inicial_os_horario = $$v;
      },
      expression: "data_inicial_os_horario"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_final_os_horario",
      "label-for": "data_final_os_horario",
      "label": "Data Final de entrada"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_final_os_horario,
      callback: function callback($$v) {
        _vm.data_final_os_horario = $$v;
      },
      expression: "data_final_os_horario"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "filterable": false,
      "options": _vm.clientes
    },
    on: {
      "input": _vm.setClienteHorario,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.cliente_os_horario,
      callback: function callback($$v) {
        _vm.cliente_os_horario = $$v;
      },
      expression: "cliente_os_horario"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Técnico",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarTecnico",
    attrs: {
      "filterable": false,
      "options": _vm.tecnicos
    },
    on: {
      "input": _vm.setTecnicoHorario,
      "open": _vm.onSearchTecnico,
      "search": _vm.onSearchTecnico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.tecnico_os_horario,
      callback: function callback($$v) {
        _vm.tecnico_os_horario = $$v;
      },
      expression: "tecnico_os_horario"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do técnico ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Objeto",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarObjeto",
    attrs: {
      "filterable": false,
      "options": _vm.objetos
    },
    on: {
      "input": _vm.setObjetoHorario,
      "open": _vm.onSearchObjeto,
      "search": _vm.onSearchObjeto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.descricao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.objeto_os_horario,
      callback: function callback($$v) {
        _vm.objeto_os_horario = $$v;
      },
      expression: "objeto_os_horario"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descrição do objeto ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Selecione o status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.osStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.statusSelectedHorario,
      callback: function callback($$v) {
        _vm.statusSelectedHorario = $$v;
      },
      expression: "statusSelectedHorario"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Comissão do técnico no serviço",
      "label-for": "comissao_tecnico"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "comissao_tecnico",
      "name": "comissao_tecnico"
    },
    model: {
      value: _vm.comissao_tecnico_servico_horario,
      callback: function callback($$v) {
        _vm.comissao_tecnico_servico_horario = $$v;
      },
      expression: "comissao_tecnico_servico_horario"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Solicitante",
      "label-for": "solicitante"
    }
  }, [_c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "id": "solicitante",
      "name": "solicitante"
    },
    model: {
      value: _vm.solicitante_horario,
      callback: function callback($$v) {
        _vm.solicitante_horario = $$v;
      },
      expression: "solicitante_horario"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escolha a ordenação",
      "label-for": "ordenacao"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ordenacao_horario,
      expression: "ordenacao_horario"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordenacao_horario",
      "id": "ordenacao_horario"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.ordenacao_horario = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.ordenacao_os_horario, function (o, index) {
    return _c('option', {
      key: 'campo' + index,
      domProps: {
        "value": o.campo
      }
    }, [_vm._v(" " + _vm._s(o.descricao) + " ")]);
  }), 0)])], 1)], 1), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.gerarResumoOSByHorarios();
      }
    }
  }, [_vm._v(" Gerar ")])], 1)])], 1)]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', [_vm._v("Resumo das Ordens de Serviço Simplificada:")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_inicial_simplificada",
      "label-for": "data_inicial_simplificada",
      "label": "Data Inicial de manutenção"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_inicial_simplificada,
      callback: function callback($$v) {
        _vm.data_inicial_simplificada = $$v;
      },
      expression: "data_inicial_simplificada"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_final_simplificada",
      "label-for": "data_final_simplificada",
      "label": "Data Final de manutenção"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_final_simplificada,
      callback: function callback($$v) {
        _vm.data_final_simplificada = $$v;
      },
      expression: "data_final_simplificada"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "filterable": false,
      "options": _vm.clientes
    },
    on: {
      "input": _vm.setClienteSimplificada,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.cliente_simplificada,
      callback: function callback($$v) {
        _vm.cliente_simplificada = $$v;
      },
      expression: "cliente_simplificada"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Técnico",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarTecnico",
    attrs: {
      "filterable": false,
      "options": _vm.tecnicos
    },
    on: {
      "input": _vm.setTecnicoSimplificada,
      "open": _vm.onSearchTecnico,
      "search": _vm.onSearchTecnico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.tecnico_simplificada,
      callback: function callback($$v) {
        _vm.tecnico_simplificada = $$v;
      },
      expression: "tecnico_simplificada"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do técnico ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Objeto",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarObjeto",
    attrs: {
      "filterable": false,
      "options": _vm.objetos
    },
    on: {
      "input": _vm.setObjetoSimplificada,
      "open": _vm.onSearchObjeto,
      "search": _vm.onSearchObjeto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.descricao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.objeto_simplificada,
      callback: function callback($$v) {
        _vm.objeto_simplificada = $$v;
      },
      expression: "objeto_simplificada"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descrição do objeto ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Selecione o status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.osStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.statusSelectedSimplificada,
      callback: function callback($$v) {
        _vm.statusSelectedSimplificada = $$v;
      },
      expression: "statusSelectedSimplificada"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escolha a ordenação",
      "label-for": "ordenacao"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ordenacao_simplificada,
      expression: "ordenacao_simplificada"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordenacao_simplificada",
      "id": "ordenacao_simplificada"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.ordenacao_simplificada = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.ordenacao_os_simplificada, function (o, index) {
    return _c('option', {
      key: 'campo' + index,
      domProps: {
        "value": o.campo
      }
    }, [_vm._v(" " + _vm._s(o.descricao) + " ")]);
  }), 0)])], 1)], 1), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.gerarSimplificada();
      }
    }
  }, [_vm._v(" Gerar ")])], 1)])], 1)])], 1), _c('hr'), _c('h4', [_vm._v("NFS-e")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', [_vm._v("Resumo das NFS-e:")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_inicial_nfse",
      "label-for": "data_inicial_nfse",
      "label": "Data Inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_inicial_nfse,
      callback: function callback($$v) {
        _vm.data_inicial_nfse = $$v;
      },
      expression: "data_inicial_nfse"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_final_nfse",
      "label-for": "data_final_nfse",
      "label": "Data Final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_final_nfse,
      callback: function callback($$v) {
        _vm.data_final_nfse = $$v;
      },
      expression: "data_final_nfse"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "filterable": false,
      "options": _vm.clientes
    },
    on: {
      "input": _vm.setClienteNFSe,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }]),
    model: {
      value: _vm.cliente_nfse,
      callback: function callback($$v) {
        _vm.cliente_nfse = $$v;
      },
      expression: "cliente_nfse"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escolha a ordenação",
      "label-for": "ordenacao"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ordenacao_nfse,
      expression: "ordenacao_nfse"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordenacao_nfse",
      "id": "ordenacao_nfse"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.ordenacao_nfse = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.ordenacao_nfses, function (o, index) {
    return _c('option', {
      key: 'campo' + index,
      domProps: {
        "value": o.campo
      }
    }, [_vm._v(" " + _vm._s(o.descricao) + " ")]);
  }), 0)])], 1)], 1), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.gerarResumoNFSe();
      }
    }
  }, [_vm._v(" Gerar ")])], 1)])], 1)])], 1), _c('hr'), _c('h4', [_vm._v("Contrato")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', [_vm._v("Contratos:")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_inicial_contrato",
      "label-for": "data_inicial_contrato",
      "label": "Data Inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_inicial_contrato,
      callback: function callback($$v) {
        _vm.data_inicial_contrato = $$v;
      },
      expression: "data_inicial_contrato"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_final_contrato",
      "label-for": "data_final_contrato",
      "label": "Data Final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.data_final_contrato,
      callback: function callback($$v) {
        _vm.data_final_contrato = $$v;
      },
      expression: "data_final_contrato"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escolha a ordenação",
      "label-for": "ordenacao"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ordenacao_contrato,
      expression: "ordenacao_contrato"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ordenacao_contrato",
      "id": "ordenacao_contrato"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.ordenacao_contrato = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.ordenacao_contratos, function (o, index) {
    return _c('option', {
      key: 'campo' + index,
      domProps: {
        "value": o.campo
      }
    }, [_vm._v(" " + _vm._s(o.descricao) + " ")]);
  }), 0)])], 1)], 1), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.gerarResumoContratos();
      }
    }
  }, [_vm._v(" Gerar ")])], 1)])], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };